import { useState, useEffect } from 'react';
import { Route } from '../types';

export function useRoutes() {
  const [routes, setRoutes] = useState<Route[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadRoutes = async () => {
      try {
        setLoading(true);
        setError(null);

        // Load from JSON file - service worker will handle caching
        const response = await fetch('/data/sampleRoutes.json');
        if (!response.ok) {
          throw new Error(`Failed to load routes: ${response.statusText}`);
        }

        const routesData: Route[] = await response.json();

        // Load classics list and flag classics
        let classics: string[] = [];
        try {
          const classicsRes = await fetch('/data/classics.json');
          if (classicsRes.ok) {
            classics = await classicsRes.json();
          }
        } catch (_) {
          // ignore classics fetch failure
        }
        const classicSet = new Set(classics.map(name => String(name).toLowerCase()));
        const enrichedRoutes: Route[] = routesData.map(r => ({
          ...r,
          isClassic: classicSet.has(String(r.Route || '').toLowerCase())
        }));
        
        setRoutes(enrichedRoutes);
      } catch (err) {
        const errorMessage = err instanceof Error ? err.message : 'Failed to load routes';
        setError(errorMessage);
        console.error('Error loading routes:', err);
      } finally {
        setLoading(false);
      }
    };

    loadRoutes();
  }, []);

  return { routes, loading, error };
}
